import React, { useEffect, useState } from 'react';
import { ArrowRight, ArrowLeft } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
interface MobileBottomCTAProps {
  nextCaseStudySlug?: string;
  nextCaseStudyTitle?: string;
}
export function MobileBottomCTA({
  nextCaseStudySlug,
  nextCaseStudyTitle
}: MobileBottomCTAProps) {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 p-4 bg-white/90 backdrop-blur-md border-t border-gray-200 z-50 transform transition-transform duration-300 translate-y-0" data-id="element-377">
      <button onClick={() => {
      if (nextCaseStudySlug) {
        navigate(`/case-study/${nextCaseStudySlug}`);
        window.scrollTo(0, 0);
      } else {
        navigate('/');
        window.scrollTo(0, 0);
      }
    }} className={`w-full flex items-center ${nextCaseStudySlug ? 'justify-between' : 'justify-center gap-2'} bg-black text-white px-6 py-3.5 rounded-xl font-medium text-sm active:scale-[0.98] transition-transform`} data-id="element-378">
        {nextCaseStudySlug ? <>
            <span data-id="element-379">{`Next: ${nextCaseStudyTitle}`}</span>
            <ArrowRight className="w-4 h-4" data-id="element-380" />
          </> : <>
            <ArrowLeft className="w-4 h-4" data-id="element-381" />
            <span data-id="element-382">Back to home</span>
          </>}
      </button>
    </div>;
}